import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ProductoService {
  static async getAll() {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/productos`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async create(nombre) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${adminUrl}/productos/create`, { data: { nombre } }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async update(id, nombre) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(`${adminUrl}/productos/${id}`, { data: { nombre } }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async remove(id) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.delete(`${adminUrl}/productos/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok' };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
